import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "src/app/shared/enums/popup-types";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { AuthService } from "src/app/auth/service/auth.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PasswordCustomValidators } from "src/app/shared/validators/password.validator";

@Component({
  selector: "app-user-new-password",
  templateUrl: "./user-profile-new-password.component.html",
  standalone: false,
})
export class UserNewPasswordComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private authServie: AuthService,
    public translate: TranslateService,
  ) {}

  @Input() email!: string;
  form!: FormGroup;
  loading = false;
  @Output() notifyWhenSend: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit() {
    this.form = this.fb.group(
      {
        current_password: ["", Validators.required],
        password: ["", [Validators.required, PasswordCustomValidators.passwordValidator]],
        confirm_password: ["", Validators.required],
      },
      { validators: PasswordCustomValidators.checkPasswords() },
    );
  }

  submitForm() {
    if (this.form.valid)
      this.updatePassword();
    else this.form.markAllAsTouched();
  }

  updatePassword() {
    this.loading = true;
    const updatePassSub = this.authServie.updatePassword(this.fetchData()).subscribe({
      next: () => {
        updatePassSub.unsubscribe();
        this.notifyWhenSend.emit(true);
        this.loading = false;
        showMessage(PopupType.Success, this.translate.instant("password_updated_successfully"));
      },
      error: (error) => {
        updatePassSub.unsubscribe();
        this.notifyWhenSend.emit(false);
        this.loading = false;
        showMessage(PopupType.Danger, error.error.message || error.toString());
      },
    });
  }

  fetchData() {
    const { current_password, password } = this.form.getRawValue();
    const data = {
      email: this.email,
      currentPassword: current_password,
      newPassword: password,
    };
    return data;
  }
}
